import React from "react";

import { KeywordManagement } from "@components/Keyword";

export default function KeywordIndex() {
  return <KeywordManagement showModalCreate showCreate={false} />;
}
